import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import { accountPasswordLogin as _accountPasswordLogin, smsCodeLogin as _smsCodeLogin, setDocType as _setDocType, logingout as _logingout, updateUserInfo as _updateUserInfo } from '@/api/user';
import router from '@/router';
import Vue from 'vue';
import { Message } from 'element-ui';
var state = {
  code: '',
  userid: '',
  username: '',
  mobile: '',
  groupid: [],
  // 路由权限ID
  partnershipid: '',
  // 医联体ID
  hospitalid: '',
  // 医院ID
  doctype: '',
  // 账号类型
  typeName: '',
  roleName: '',
  showai: '',
  // 是否显示ai功能
  canedit: '',
  // 审核后是否可以编辑
  aiopen: '',
  // 是否开启ai功能
  tijianopen: '',
  // 是否开启体检报告选择
  forcerecord: '',
  // 申请远程是否强制填写简要病史
  mustcontent: '' // 编辑患者信息，申请远程是否开启必填项

};
var mutations = {
  SET_MUSTCONTENT: function SET_MUSTCONTENT(state, mustcontent) {
    state.mustcontent = mustcontent;
  },
  SET_FORCERECORD: function SET_FORCERECORD(state, forcerecord) {
    state.forcerecord = forcerecord;
  },
  SET_CODE: function SET_CODE(state, code) {
    state.code = code;
  },
  SET_USERID: function SET_USERID(state, userid) {
    state.userid = userid;
  },
  SET_USERNAME: function SET_USERNAME(state, username) {
    state.username = username;
  },
  SET_MOBILE: function SET_MOBILE(state, mobile) {
    state.mobile = mobile;
  },
  SET_GROUPID: function SET_GROUPID(state, groupid) {
    state.groupid = groupid;
  },
  SER_PARTNERSHIPID: function SER_PARTNERSHIPID(state, partnershipid) {
    state.partnershipid = partnershipid;
  },
  SET_HOSPITALID: function SET_HOSPITALID(state, hospitalid) {
    state.hospitalid = hospitalid;
  },
  SET_DOCTYPE: function SET_DOCTYPE(state, doctype) {
    state.doctype = doctype;
  },
  SET_TYPENAME: function SET_TYPENAME(state, typeName) {
    state.typeName = typeName;
  },
  SET_TYPEROLENAME: function SET_TYPEROLENAME(state, roleName) {
    state.roleName = roleName;
  },
  SET_SHOWAI: function SET_SHOWAI(state, ai) {
    state.showai = ai;
  },
  SET_CANEDIT: function SET_CANEDIT(state, canedit) {
    state.canedit = canedit;
  },
  SET_AIOPEN: function SET_AIOPEN(state, aiopen) {
    state.aiopen = aiopen;
  },
  SET_TIJIANOPEN: function SET_TIJIANOPEN(state, tijianopen) {
    state.tijianopen = tijianopen;
  }
};
var actions = {
  // 账号密码登录
  accountPasswordLogin: function accountPasswordLogin(_ref, userInfo) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      _accountPasswordLogin(userInfo).then(function (response) {
        var _response$list = response.list,
            username = _response$list.username,
            userid = _response$list.userid,
            mobile = _response$list.mobile;
        commit('SET_USERNAME', username);
        commit('SET_USERID', userid);
        commit('SET_MOBILE', mobile);
        resolve(response.list);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 验证码登录
  smsCodeLogin: function smsCodeLogin(_ref2, userInfo) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      _smsCodeLogin(userInfo).then(function (response) {
        var _response$list2 = response.list,
            username = _response$list2.username,
            userid = _response$list2.userid,
            mobile = _response$list2.mobile;
        commit('SET_USERNAME', username);
        commit('SET_USERID', userid);
        commit('SET_MOBILE', mobile);
        resolve(response.list);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 选择账号类型
  setDocType: function setDocType(_ref3, doctorid) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    return new Promise(function (resolve, reject) {
      _setDocType(doctorid).then(function (response) {
        if (response.info == 'ok') {
          var _response$list3 = response.list,
              code = _response$list3.code,
              groupid = _response$list3.groupid,
              partnershipid = _response$list3.partnershipid,
              hospitalid = _response$list3.hospitalid,
              rightlist = _response$list3.rightlist,
              doctype = _response$list3.doctype,
              name = _response$list3.name,
              rolename = _response$list3.rolename,
              showai = _response$list3.showai,
              canedit = _response$list3.canedit,
              aiopen = _response$list3.aiopen,
              tijianopen = _response$list3.tijianopen,
              forcerecord = _response$list3.forcerecord,
              mustcontent = _response$list3.mustcontent;
          var groupid2 = groupid;

          if (showai == '0') {
            groupid2 = groupid2.replace('210001', "");
          } // 医院账号开放统计菜单


          if (doctype == '3') {
            groupid2 += ',190001,190002';
          } // 医联体账号新增在线医生列表,检索列表


          if (doctype == '2') {
            groupid2 += ',2100001,2100002';
          } // 云端账号新增检索列表


          if (doctype == '1') {
            groupid2 += ',2100002';
          } // 所有账号类型添加


          groupid2 += ',140003';
          commit('SET_CODE', code);
          commit('SET_GROUPID', groupid2);
          commit('SER_PARTNERSHIPID', partnershipid);
          commit('SET_HOSPITALID', hospitalid);
          commit('SET_DOCTYPE', doctype);
          commit('SET_TYPENAME', name);
          commit('SET_TYPEROLENAME', rolename);
          commit('SET_SHOWAI', showai);
          commit('SET_CANEDIT', canedit);
          commit('SET_AIOPEN', aiopen);
          commit('SET_TIJIANOPEN', tijianopen);
          commit('SET_FORCERECORD', forcerecord);
          commit('SET_MUSTCONTENT', mustcontent); // 路由权限

          dispatch('permission/generateRoutes', groupid2, {
            root: true
          }); // 报告权限

          dispatch('permission/setReportPermission', response.list, {
            root: true
          }); // 所有权限

          dispatch('permission/setRights', rightlist, {
            root: true
          });
          resolve(response);
        } else {
          Message({
            message: response.info,
            type: 'error'
          });
          resolve(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 个人中心修改基本信息
  updateUserInfo: function updateUserInfo(_ref4, editInfo) {
    var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      _updateUserInfo(editInfo).then(function (response) {
        var newUserName = Vue.prototype.qs.parse(editInfo).username;
        commit('SET_USERNAME', newUserName);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 退出账号
  logingout: function logingout(_ref5) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return new Promise(function (resolve, reject) {
      _logingout().then(function () {
        // 清楚个人信息
        commit('SET_CODE', '');
        commit('SET_USERNAME', '');
        commit('SET_USERID', '');
        commit('SET_MOBILE', '');
        commit('SET_GROUPID', []);
        commit('SER_PARTNERSHIPID', '');
        commit('SET_HOSPITALID', '');
        commit('SET_DOCTYPE', '');
        commit('SET_TYPENAME', '');
        commit('SET_SHOWAI', ''); // 清除权限

        dispatch('permission/clearPermisson', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  clearData: function clearData(_ref6) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;
    // 清除个人信息
    commit('SET_CODE', '');
    commit('SET_USERNAME', '');
    commit('SET_USERID', '');
    commit('SET_MOBILE', '');
    commit('SET_GROUPID', []);
    commit('SER_PARTNERSHIPID', '');
    commit('SET_HOSPITALID', '');
    commit('SET_DOCTYPE', '');
    commit('SET_SHOWAI', ''); // 清除权限

    dispatch('permission/clearPermisson', null, {
      root: true
    });
    router.push('/login');
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};